/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Roomannouncementlabel2Inputs */

const en_roomannouncementlabel2 = /** @type {(inputs: Roomannouncementlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Announcement to everyone inside`)
};

const de_roomannouncementlabel2 = /** @type {(inputs: Roomannouncementlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ankündigung an alle im Raum`)
};

/**
* | output |
* | --- |
* | "Announcement to everyone inside" |
*
* @param {Roomannouncementlabel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const roomannouncementlabel2 = /** @type {((inputs?: Roomannouncementlabel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Roomannouncementlabel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_roomannouncementlabel2(inputs)
	return de_roomannouncementlabel2(inputs)
});
export { roomannouncementlabel2 as "roomAnnouncementLabel" }